import React from 'react';
import Loadable from 'react-loadable';

import { FooterTheme } from '@rover/kibble/styles';
import { CONCEPTS } from '@rover/rsdk/src/concepts';
import retry from '@rover/rsdk/src/modules/Network/retry';
import Route from '@rover/types/src/Route';

import Loading from '../client/Loading';

export const BH_HUB_PATH = '/bright-horizons';

const HubPage = Loadable({
  loader: (): Promise<React.ComponentType> =>
    retry(() =>
      import(
        /* webpackChunkName: "HubPage" */
        '@rover/pages/src/bright-horizons/HubPage'
      ).then((module) => module.default as React.ComponentType)
    ),
  loading: Loading,
});

const BH_HUB_ROUTE = {
  path: BH_HUB_PATH,
  component: HubPage,
  componentName: 'HubPage',
  exact: true,
  cacheTag: ['page-bh-hub'],
  pageName: 'ssr-bh-hub',
};

const routes: Route[] = [BH_HUB_ROUTE].map((route) => ({
  ...route,
  pageCategory: 'ssr-bh',
  concept: CONCEPTS.marketing.promos,
  cacheTag: [...route.cacheTag],
  isReactQueryRoute: true,
  requiresAuth: true,
  footerTheme: FooterTheme.DARK,
  navbarVariant: 'bright-horizons',
}));

export default routes;
